import React from 'react'
import { useEnvValue } from '@morningtrain/react-helpers'
function LowStockTip({ stock = 0 }){
  const [strLowStock] = useEnvValue('strings.lowStock','')
  const [strLowStockAmountLeft] = useEnvValue('strings.lowStockAmountLeft','')

  return (
    <div className={'tooltip-low-stock'}>
      <div className={'tooltip-low-stock__text-wrap'}>
        <div className={'tooltip-low-stock__title'}>{strLowStock}</div>
        <div className={'tooltip-low-stock__text'}><span
          className={'amount'}>{stock}</span> {strLowStockAmountLeft}
        </div>
      </div>
    </div>
  )
}

export default LowStockTip